import React, { createRef } from "react";
import { NSButton, NSButtonProps } from "./NSButton";
import Style from "./NSButtonBlue.module.css";

export class NSButtonBlue extends React.Component<NSButtonProps>
{
	private NSButton_Base = createRef<NSButton>();
	constructor(props: NSButtonProps)
	{
		super(props);
		this.performClick = this.performClick.bind(this);
	}
	performClick()
	{
		this.NSButton_Base.current?.performClick();
	}
	override render()
	{
		let classList = []
		if (this.props.classList)
			classList.push(...this.props.classList);
		classList.push(Style.ns_button_blue);

		return <NSButton
			ref={this.NSButton_Base}
			{...this.props}
			classList={classList}
		/>;
	}
}